// removed by extract-text-webpack-plugin
module.exports = {"disconnected":"disconnected__62hyA","connected":"connected__AwQCV","pager":"pager__2zsV6","noGateway":"noGateway__3XyXM","buy":"buy__37N9d","marginT":"marginT__18SPo"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayList/styles.scss
// module id = 2276
// module chunks = 1